class FeaturesAvailability {

  constructor(application) {

    this.application = application;
    this.env = import.meta.env;
    this.alwaysOnEnabledStartups = import.meta.env.REACT_APP_ASSISTANT_FEEDBACK_ENABLED_STARTUPS.split(',');
    this.developmentEnvironmentStartups = import.meta.env.REACT_APP_DEVELOPMENT_ENVIRONMENT_STARTUPS.split(',');
    this.devopsAdmins = import.meta.env.REACT_APP_DEVOPS_ADMINS.split(',');

  }

  isAssistantFeedbackEnabled() {

    return true;

  }

  isAlwaysOnAIEnabled() {

    return this.alwaysOnEnabledStartups.includes(this.application.getCurrentStartup()._id);

  }

  isSocialAnalyticsEnabled() {
    return this.alwaysOnEnabledStartups.includes(this.application.getCurrentStartup()._id);
  }

  isDevelopmentEnvironmentStartup() {

    return this.developmentEnvironmentStartups.includes(this.application.getCurrentStartup()._id);

  }

  isDevopsAdmin() {

    return this.devopsAdmins.includes(this.application.getUser()._id);

  }

  isReleaseCandidatesEnabled() {

    return this.isDevelopmentEnvironmentStartup();

  }

  isReleaseCandidatesInProgressEnabled() {

    return this.isDevelopmentEnvironmentStartup() && this.isDevopsAdmin();

  }

  isInternalToolsEnabled() {

    return this.application.isVenturz() && this.isDevopsAdmin();

  }

  isPublishersEnabled() {

    return this.isReleaseCandidatesInProgressEnabled();

  }

  isDirectoryFormChecksEnabled() {

    return this.isInternalToolsEnabled();

  }

  isAssistantMemoryEnabled() {

    return this.isReleaseCandidatesInProgressEnabled();

  }

}

export default FeaturesAvailability;
